/** Shared dark UI palette — TradingView / chart charcoal (not pure black). */
export const DARK_UI = {
  bg: "#131722",
  text: "#ffffff",
  muted: "rgba(255, 255, 255, 0.55)",
  mutedSoft: "rgba(255, 255, 255, 0.45)",
  border: "rgba(255, 255, 255, 0.12)",
  surface: "#131722",
  rowSelected: "#1e222d",
  gridLine: "rgba(255, 255, 255, 0.08)",
  inputBg: "#1a1f2c",
  buttonBg: "#1e222d",
};
